import React from 'react';
import type { RegistryEntityDetail } from '../../api/registryEntityTypes';
import { ENTITY_TYPE_LABELS, formatBusinessNumber } from '../../entities/entityFormat';
import { date } from '../../lib/format';
import { KeyValueGrid, SectionCard } from '../../ui/primitives';

const TRUSTEE_TYPE_LABELS: Record<string, string> = {
  INDIVIDUAL: 'Individual trustee(s)',
  CORPORATE: 'Corporate trustee',
};

function typeSpecificItems(entity: RegistryEntityDetail) {
  switch (entity.type) {
    case 'INDIVIDUAL':
      return [
        { label: 'First name(s)', value: entity.firstName },
        { label: 'Last name', value: entity.lastName },
      ];
    case 'TRUST':
    case 'SMSF':
      return [
        { label: 'Trust', value: entity.trustName },
        { label: 'Trustee', value: entity.trusteeName },
        {
          label: 'Trustee type',
          value: entity.trusteeType ? TRUSTEE_TYPE_LABELS[entity.trusteeType] : null,
        },
      ];
    default:
      return [{ label: 'Company name', value: entity.companyName }];
  }
}

/** The investment entity as the platform records it. */
export default function EntityDetailsCard({ entity }: { entity: RegistryEntityDetail }) {
  return (
    <SectionCard title="Investment entity">
      <KeyValueGrid
        items={[
          { label: 'Type', value: ENTITY_TYPE_LABELS[entity.type] },
          ...typeSpecificItems(entity),
          { label: 'ABN', value: formatBusinessNumber(entity.abn) },
          { label: 'ACN', value: formatBusinessNumber(entity.acn) },
          { label: 'Foreign investor', value: entity.isForeignInvestor ? 'Yes' : 'No' },
          { label: 'On Fides since', value: date(entity.createdAt) },
          ...(entity.description ? [{ label: 'Description', value: entity.description }] : []),
        ]}
      />
    </SectionCard>
  );
}
